var _style, _line, _line2, _line3, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemovableManualControl({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}\n")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 8.5,
    y1: 8,
    x2: 9.9,
    y2: 8
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 10.7,
    y1: 8,
    x2: 12.7,
    y2: 8
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 13.9,
    y1: 8,
    x2: 15.8,
    y2: 8
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.7,
    y: 5.1,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -4.3282 5.5368)",
    className: "st0",
    width: 5.6,
    height: 5.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemovableManualControl);
export default __webpack_public_path__ + "static/media/RemovableManualControl.df56a18c4bcbab602d5c54a749288186.svg";
export { ForwardRef as ReactComponent };